import { getSintegradaServerApi } from "@/services/api";

import { Patient } from "@/@types/sintegrada/sintegradaServerApi/Patient";
import { Risk } from "@/@types/sintegrada/sintegradaServerApi/Risk";
import { DataCollection, Pagination } from "@/@types/sintegrada/sintegradaServerApi/Pagination";

type DischargeSummaryParams = {
	page?: number;
	search?: string;
	ibgeCode: string;
	discharge_start_date: string;
	discharge_end_date: string;
	department: string;
	specialty_id: number | null;
	discharge_type: number | null;
	min_age: number | null;
	max_age: number | null;
	gender: string | null;
	transfer_unit_id: number | null;
	all_results?: number;
};

export type Discharge = {
	id: number;
	admission_date: string;
	discharge_date: string;
	discharge_type: string;
	patient: Patient;
	risk: Risk;
	professional_name: string;
	transfer_unit_name: string;
};

export type DischargeTypeTotal = {
	total: number;
	discharge_type: number;
};

export type DischargeSummary = DataCollection<DischargeTypeTotal>;

export type PaginatedDischarge = Pagination<Discharge>;

export async function getDischargeSummary(params: DischargeSummaryParams) {
	const url = "/discharge-summary";

	const { data } = await getSintegradaServerApi().get<PaginatedDischarge | DischargeSummary>(url, {
		...params,
	});

	return data;
}